// src/lib/sheetsSafe.js
import { fetchSheetViaProxy } from "./sheets";

/**
 * Holt einen Range sicher. Liefert {ok:true,data} oder {ok:false,message}
 * statt Exceptions durchzureichen.
 */
export async function safeFetchSheet(range) {
    try {
        const data = await fetchSheetViaProxy({ range });
        // Wenn das Backend "invalid range" o.ä. inhaltlich zurückgibt:
        if (!data || (!data.values && !data.rows)) {
            return { ok: false, message: "Keine Daten gefunden." };
        }
        return { ok: true, data };
    } catch (e) {
        const msg = String(e?.message || e);

        // Häufige Google-Sheets-Fehlertexte abfangen:
        const friendly =
            /Unable to parse range|Requested entity was not found|Invalid argument|Unable to parse/gi.test(
                msg
            )
                ? "Rennen hat noch nicht stattgefunden oder wurde noch nicht ausgewertet."
                : "Fehler beim Laden der Daten.";

        return { ok: false, message: friendly };
    }
}
